import * as Immutable from 'immutable';
import * as React from 'react';
import { injectIntl, WrappedComponentProps as InjectedIntlProps } from 'react-intl';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { closeEventsCards, getEvents } from '../../actions/Events/DataActions';
import { changeFilter, changeFilterOpen } from '../../actions/Events/FiltersActions';
import { localeData } from '../../locales/data';
import { StateType } from '../../reducers';
import { BaseFiltersOptions } from '../../reducers/Events/FiltersReducer/FiltersReducer.types';
import {
  eventFiltersCityOptionsSelector,
  eventFiltersCitySelector,
  eventFiltersCountryOptionsSelector,
  eventFiltersCountrySelector,
  eventFiltersFilterOpenSelector,
  eventFiltersIsFetchingSelector,
  eventFiltersLanguageOptionsSelector,
  eventFiltersLanguageSelector,
  eventFiltersTypeOptionsSelector,
  eventFiltersTypeSelector,
} from '../../reducers/Events/FiltersReducer/FiltersSelector';
import { addModifiers, intlFormatMessage } from '../../shared/helpers';
import { formatMessageHelper, FormattedMessageHelper } from '../../shared/helpers/internationalization';
import { DispatchConnect } from '../../types/';
import { ActiveFilters } from '../ActiveFilters/ActiveFilters';
import { FilterMenu } from '../FilterMenu';

import { EventsHeaderDispatchToProps, EventsHeaderMenuTopProps, EventsHeaderPropsGeneric, EventsHeaderStateToProps } from './types';

const EventsHeaderTop = () => (
  <div className="events__header">
    <h2 className="events__header-title">
      <FormattedMessageHelper tagName="span" id="events.events" defaultMessage={localeData.en['events.events']} />
    </h2>
    <div className="events__header-types">
      <div className="events__header-type events__header-type--webinar">
        <FormattedMessageHelper tagName="span" id="events.online" defaultMessage={localeData.en['events.online']} />
      </div>
      <div className="events__header-type">
        <FormattedMessageHelper tagName="span" id="events.atvenue" defaultMessage={localeData.en['events.atvenue']} />
      </div>
    </div>
  </div>
);

const EventsHeaderMenuTop = injectIntl(
  ({
    handlerToogleFilter,
    filterOpen,
    values,
    dispatchChangeFilter,
    languageOptions,
    typeOptions,
    countryOptions,
    dispatchGetEvents,
    cityOptions,
    intl,
  }: EventsHeaderMenuTopProps & InjectedIntlProps) => {
    const toogleFilter = () => handlerToogleFilter(!filterOpen);
    let filters: any[] = [];

    [
      { name: 'type', options: typeOptions },
      { name: 'language', options: languageOptions },
      { name: 'country', options: countryOptions },
      { name: 'city', options: cityOptions },
    ].forEach((filter: { name: string; options: Immutable.List<BaseFiltersOptions> }) => {
      if (values[filter.name] !== '' && filter.options) {
        const result = filter.options.filter((key: any) => key.get('value') === values[filter.name]);
        filters = filters.concat({
          label: intlFormatMessage(`active-filters-${filter.name}`, intl),
          value: result.getIn([0, 'text']),
          id: filter.name,
        });
      }
    });

    const handlerRemove = (filter: string) => {
      dispatchChangeFilter({ [filter]: '' });
      dispatchGetEvents();
    };

    return (
      <div className="events__menu-filter-wrapper">
        <ActiveFilters filters={filters} handleRemoveFilter={handlerRemove} />
        <button className={addModifiers('events__filter-button', filterOpen ? ['active'] : [])} onClick={toogleFilter}>
          <FormattedMessageHelper tagName="span" id="events.filter" defaultMessage={localeData.en['events.filter']} />
        </button>
      </div>
    );
  }
);

const EventsHeader = injectIntl(
  ({
    type,
    language,
    country,
    city,
    typeOptions,
    languageOptions,
    countryOptions,
    cityOptions,
    filterOpen,
    isFetching,
    dispatchChangeFilterOpen,
    dispatchChangeFilter,
    dispatchGetEvents,
    dispatchCloseEventsCards,
    intl,
  }: EventsHeaderPropsGeneric & InjectedIntlProps) => {
    const filters = [
      { name: 'type', label: formatMessageHelper(intl, 'events.filter.placeholder.type'), choices: typeOptions.toJS() },
      { name: 'language', label: formatMessageHelper(intl, 'events.filter.placeholder.language'), choices: languageOptions.toJS() },
      { name: 'country', label: formatMessageHelper(intl, 'events.filter.placeholder.country'), choices: countryOptions.toJS() },
      { name: 'city', label: formatMessageHelper(intl, 'events.filter.placeholder.city'), choices: cityOptions.toJS() },
    ];
    const filterValues = {
      type: type,
      language: language,
      country: country,
      city: city,
    };
    const handlerRemove = (filter: string) => {
      dispatchChangeFilter({ [filter]: '' });
      dispatchGetEvents();
      dispatchCloseEventsCards();
    };
    const handlerChange = (_: any, data: any, filter?: string) => {
      const filterName: any = filter ? filter : '';
      dispatchChangeFilter({ [filterName]: data.value });
      dispatchGetEvents();
      dispatchCloseEventsCards();
    };

    return (
      <div className="events__header-content">
        <EventsHeaderTop />
        <div className="events__menu">
          <EventsHeaderMenuTop
            handlerToogleFilter={dispatchChangeFilterOpen}
            filterOpen={filterOpen}
            dispatchChangeFilter={dispatchChangeFilter}
            values={{ type, language, country, city }}
            languageOptions={languageOptions}
            typeOptions={typeOptions}
            countryOptions={countryOptions}
            cityOptions={cityOptions}
            dispatchGetEvents={dispatchGetEvents}
          />

          <div className={addModifiers('events__menu-filters-content', filterOpen ? ['active'] : [])}>
            <FilterMenu
              filters={filters}
              filterValues={filterValues}
              filterType="events"
              handleCloseFilter={handlerRemove}
              handleChangeFilter={handlerChange}
            />
          </div>
        </div>
      </div>
    );
  }
);

const mapStateToProps = (state: StateType): EventsHeaderStateToProps => ({
  // @ts-ignore
  type: eventFiltersTypeSelector(state),
  // @ts-ignore
  language: eventFiltersLanguageSelector(state),
  // @ts-ignore
  country: eventFiltersCountrySelector(state),
  // @ts-ignore
  city: eventFiltersCitySelector(state),
  // @ts-ignore
  typeOptions: eventFiltersTypeOptionsSelector(state),
  // @ts-ignore
  languageOptions: eventFiltersLanguageOptionsSelector(state),
  // @ts-ignore
  countryOptions: eventFiltersCountryOptionsSelector(state),
  // @ts-ignore
  cityOptions: eventFiltersCityOptionsSelector(state),
  // @ts-ignore
  filterOpen: eventFiltersFilterOpenSelector(state),
  // @ts-ignore
  isFetching: eventFiltersIsFetchingSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch<any>): EventsHeaderDispatchToProps => ({
  dispatchChangeFilterOpen: (action: boolean) => {
    dispatch(changeFilterOpen(action));
  },
  dispatchChangeFilter: (filter: { [key: string]: string }) => {
    dispatch(changeFilter(filter));
  },
  dispatchGetEvents: () => {
    dispatch(getEvents());
  },
  dispatchCloseEventsCards: () => dispatch(closeEventsCards()),
});

export default connect<EventsHeaderStateToProps, DispatchConnect<EventsHeaderDispatchToProps>, any, StateType>(
  mapStateToProps,
  mapDispatchToProps
)(EventsHeader);
